module.exports = __webpack_public_path__ + "img/no-records-assets.c66b9e5c.png";